


























































import {Component, Vue} from 'vue-property-decorator'
import {routes} from '@/router'

@Component({
  components: {},
})
export default class SideNav extends Vue {
  private navDisplay = true
  private optDisplay = true
  private widgetsDisplay = true

  get computedRoutes() {
    const r: any[] = []
    routes.forEach((route: any) => {
        if (route.hasOwnProperty('meta') && route.meta.hasOwnProperty('title')) {
          r.push(route)
        }
      },
    )
    return r
  }

  private isCurrentRoute(r: string): boolean {
    return this.$router.currentRoute.name === r
  }
}
